function notEmpty(value: string | undefined | null): boolean {
    return value !== undefined && value !== null && value.length > 0
}

(window as any).notEmpty = notEmpty

function exists(value: any): boolean {
    return value !== undefined && value !== null
}

(window as any).exists = exists
